// GENERATED — run `just nx run design-system:gen-icons` to update.
// Source: node_modules/lucide-static/icon-nodes.json (1857 icons)

export const ICON_NAME_TO_KEBAB = {
  AArrowDown: "a-arrow-down",
  AArrowUp: "a-arrow-up",
  ALargeSmall: "a-large-small",
  Accessibility: "accessibility",
  Activity: "activity",
  Ad: "ad",
  AirVent: "air-vent",
  Airplay: "airplay",
  AlarmClock: "alarm-clock",
  AlarmClockCheck: "alarm-clock-check",
  AlarmClockMinus: "alarm-clock-minus",
  AlarmClockOff: "alarm-clock-off",
  AlarmClockPlus: "alarm-clock-plus",
  AlarmSmoke: "alarm-smoke",
  AlignCenterHorizontal: "align-center-horizontal",
  AlignCenterVertical: "align-center-vertical",
  AlignEndHorizontal: "align-end-horizontal",
  AlignEndVertical: "align-end-vertical",
  AlignHorizontalDistributeCenter: "align-horizontal-distribute-center",
  AlignHorizontalDistributeEnd: "align-horizontal-distribute-end",
  AlignHorizontalDistributeStart: "align-horizontal-distribute-start",
  AlignHorizontalJustifyCenter: "align-horizontal-justify-center",
  AlignHorizontalJustifyEnd: "align-horizontal-justify-end",
  AlignHorizontalJustifyStart: "align-horizontal-justify-start",
  AlignHorizontalSpaceAround: "align-horizontal-space-around",
  AlignHorizontalSpaceBetween: "align-horizontal-space-between",
  AlignStartHorizontal: "align-start-horizontal",
  AlignStartVertical: "align-start-vertical",
  AlignVerticalDistributeCenter: "align-vertical-distribute-center",
  AlignVerticalDistributeEnd: "align-vertical-distribute-end",
  AlignVerticalDistributeStart: "align-vertical-distribute-start",
  AlignVerticalJustifyCenter: "align-vertical-justify-center",
  AlignVerticalJustifyEnd: "align-vertical-justify-end",
  AlignVerticalJustifyStart: "align-vertical-justify-start",
  AlignVerticalSpaceAround: "align-vertical-space-around",
  AlignVerticalSpaceBetween: "align-vertical-space-between",
  Ambulance: "ambulance",
  Ampersand: "ampersand",
  Ampersands: "ampersands",
  Amphora: "amphora",
  Anchor: "anchor",
  Angle: "angle",
  Antenna: "antenna",
  Anvil: "anvil",
  Aperture: "aperture",
  AppWindow: "app-window",
  AppWindowMac: "app-window-mac",
  Apple: "apple",
  Archive: "archive",
  ArchiveRestore: "archive-restore",
  ArchiveX: "archive-x",
  Armchair: "armchair",
  ArrowBigDown: "arrow-big-down",
  ArrowBigDownDash: "arrow-big-down-dash",
  ArrowBigLeft: "arrow-big-left",
  ArrowBigLeftDash: "arrow-big-left-dash",
  ArrowBigRight: "arrow-big-right",
  ArrowBigRightDash: "arrow-big-right-dash",
  ArrowBigUp: "arrow-big-up",
  ArrowBigUpDash: "arrow-big-up-dash",
  ArrowDown: "arrow-down",
  ArrowDown01: "arrow-down-0-1",
  ArrowDown10: "arrow-down-1-0",
  ArrowDownAZ: "arrow-down-a-z",
  ArrowDownFromLine: "arrow-down-from-line",
  ArrowDownLeft: "arrow-down-left",
  ArrowDownNarrowWide: "arrow-down-narrow-wide",
  ArrowDownRight: "arrow-down-right",
  ArrowDownToDot: "arrow-down-to-dot",
  ArrowDownToLine: "arrow-down-to-line",
  ArrowDownUp: "arrow-down-up",
  ArrowDownWideNarrow: "arrow-down-wide-narrow",
  ArrowDownZA: "arrow-down-z-a",
  ArrowLeft: "arrow-left",
  ArrowLeftFromLine: "arrow-left-from-line",
  ArrowLeftRight: "arrow-left-right",
  ArrowLeftToLine: "arrow-left-to-line",
  ArrowRight: "arrow-right",
  ArrowRightFromLine: "arrow-right-from-line",
  ArrowRightLeft: "arrow-right-left",
  ArrowRightToLine: "arrow-right-to-line",
  ArrowUp: "arrow-up",
  ArrowUp01: "arrow-up-0-1",
  ArrowUp10: "arrow-up-1-0",
  ArrowUpAZ: "arrow-up-a-z",
  ArrowUpDown: "arrow-up-down",
  ArrowUpFromDot: "arrow-up-from-dot",
  ArrowUpFromLine: "arrow-up-from-line",
  ArrowUpLeft: "arrow-up-left",
  ArrowUpNarrowWide: "arrow-up-narrow-wide",
  ArrowUpRight: "arrow-up-right",
  ArrowUpToLine: "arrow-up-to-line",
  ArrowUpWideNarrow: "arrow-up-wide-narrow",
  ArrowUpZA: "arrow-up-z-a",
  ArrowsUpFromLine: "arrows-up-from-line",
  Asterisk: "asterisk",
  Astroid: "astroid",
  AtSign: "at-sign",
  Atom: "atom",
  AudioLines: "audio-lines",
  AudioLinesOff: "audio-lines-off",
  AudioLinesX: "audio-lines-x",
  AudioWaveform: "audio-waveform",
  Award: "award",
  Axe: "axe",
  Axis3d: "axis-3d",
  Baby: "baby",
  Backpack: "backpack",
  Badge: "badge",
  BadgeAlert: "badge-alert",
  BadgeCent: "badge-cent",
  BadgeCheck: "badge-check",
  BadgeDollarSign: "badge-dollar-sign",
  BadgeEuro: "badge-euro",
  BadgeIndianRupee: "badge-indian-rupee",
  BadgeInfo: "badge-info",
  BadgeJapaneseYen: "badge-japanese-yen",
  BadgeMinus: "badge-minus",
  BadgePercent: "badge-percent",
  BadgePlus: "badge-plus",
  BadgePoundSterling: "badge-pound-sterling",
  BadgeQuestionMark: "badge-question-mark",
  BadgeRussianRuble: "badge-russian-ruble",
  BadgeSwissFranc: "badge-swiss-franc",
  BadgeTurkishLira: "badge-turkish-lira",
  BadgeX: "badge-x",
  BaggageClaim: "baggage-claim",
  Balloon: "balloon",
  Ban: "ban",
  Banana: "banana",
  Bandage: "bandage",
  BangladeshiTaka: "bangladeshi-taka",
  Banknote: "banknote",
  BanknoteArrowDown: "banknote-arrow-down",
  BanknoteArrowUp: "banknote-arrow-up",
  BanknoteCheck: "banknote-check",
  BanknoteX: "banknote-x",
  Barcode: "barcode",
  Barrel: "barrel",
  Baseline: "baseline",
  Bath: "bath",
  Battery: "battery",
  BatteryCharging: "battery-charging",
  BatteryFull: "battery-full",
  BatteryLow: "battery-low",
  BatteryMedium: "battery-medium",
  BatteryPlus: "battery-plus",
  BatteryWarning: "battery-warning",
  Beaker: "beaker",
  Bean: "bean",
  BeanOff: "bean-off",
  Bed: "bed",
  BedDouble: "bed-double",
  BedSingle: "bed-single",
  Beef: "beef",
  BeefOff: "beef-off",
  Beer: "beer",
  BeerOff: "beer-off",
  Bell: "bell",
  BellCheck: "bell-check",
  BellDot: "bell-dot",
  BellElectric: "bell-electric",
  BellMinus: "bell-minus",
  BellOff: "bell-off",
  BellPlus: "bell-plus",
  BellRing: "bell-ring",
  BetweenHorizontalEnd: "between-horizontal-end",
  BetweenHorizontalStart: "between-horizontal-start",
  BetweenVerticalEnd: "between-vertical-end",
  BetweenVerticalStart: "between-vertical-start",
  BicepsFlexed: "biceps-flexed",
  Bike: "bike",
  Binary: "binary",
  Binoculars: "binoculars",
  Biohazard: "biohazard",
  Bird: "bird",
  Birdhouse: "birdhouse",
  Bitcoin: "bitcoin",
  Blend: "blend",
  Blender: "blender",
  Blinds: "blinds",
  Blocks: "blocks",
  Bluetooth: "bluetooth",
  BluetoothConnected: "bluetooth-connected",
  BluetoothOff: "bluetooth-off",
  BluetoothSearching: "bluetooth-searching",
  Bold: "bold",
  Bolt: "bolt",
  Bomb: "bomb",
  Bone: "bone",
  BoneFracture: "bone-fracture",
  Book: "book",
  BookA: "book-a",
  BookAlert: "book-alert",
  BookAudio: "book-audio",
  BookBookmark: "book-bookmark",
  BookCheck: "book-check",
  BookCopy: "book-copy",
  BookDashed: "book-dashed",
  BookDown: "book-down",
  BookHeadphones: "book-headphones",
  BookHeart: "book-heart",
  BookImage: "book-image",
  BookKey: "book-key",
  BookLock: "book-lock",
  BookMinus: "book-minus",
  BookOpen: "book-open",
  BookOpenCheck: "book-open-check",
  BookOpenText: "book-open-text",
  BookPlus: "book-plus",
  BookSearch: "book-search",
  BookText: "book-text",
  BookType: "book-type",
  BookUp: "book-up",
  BookUp2: "book-up-2",
  BookUser: "book-user",
  BookX: "book-x",
  Bookmark: "bookmark",
  BookmarkCheck: "bookmark-check",
  BookmarkMinus: "bookmark-minus",
  BookmarkOff: "bookmark-off",
  BookmarkPlus: "bookmark-plus",
  BookmarkX: "bookmark-x",
  BoomBox: "boom-box",
  Bot: "bot",
  BotMessageSquare: "bot-message-square",
  BotOff: "bot-off",
  BottleWine: "bottle-wine",
  BowArrow: "bow-arrow",
  Box: "box",
  Boxes: "boxes",
  Braces: "braces",
  Brackets: "brackets",
  Brain: "brain",
  BrainCircuit: "brain-circuit",
  BrainCog: "brain-cog",
  BrickWall: "brick-wall",
  BrickWallFire: "brick-wall-fire",
  BrickWallShield: "brick-wall-shield",
  Bridge: "bridge",
  Briefcase: "briefcase",
  BriefcaseBusiness: "briefcase-business",
  BriefcaseConveyorBelt: "briefcase-conveyor-belt",
  BriefcaseMedical: "briefcase-medical",
  BriefcasePlus: "briefcase-plus",
  BringToFront: "bring-to-front",
  Broccoli: "broccoli",
  Broom: "broom",
  BroomSparkles: "broom-sparkles",
  Brush: "brush",
  BrushCleaning: "brush-cleaning",
  Bubbles: "bubbles",
  Bug: "bug",
  BugOff: "bug-off",
  BugPlay: "bug-play",
  Building: "building",
  BuildingComplex: "building-complex",
  BuildingComplexPlus: "building-complex-plus",
  Bus: "bus",
  BusFront: "bus-front",
  Cable: "cable",
  CableCar: "cable-car",
  Cake: "cake",
  CakeSlice: "cake-slice",
  Calculator: "calculator",
  Calendar: "calendar",
  Calendar1: "calendar-1",
  CalendarArrowDown: "calendar-arrow-down",
  CalendarArrowUp: "calendar-arrow-up",
  CalendarCheck: "calendar-check",
  CalendarCheck2: "calendar-check-2",
  CalendarChevronsRight: "calendar-chevrons-right",
  CalendarClock: "calendar-clock",
  CalendarCog: "calendar-cog",
  CalendarDays: "calendar-days",
  CalendarFold: "calendar-fold",
  CalendarHeart: "calendar-heart",
  CalendarMinus: "calendar-minus",
  CalendarMinus2: "calendar-minus-2",
  CalendarOff: "calendar-off",
  CalendarPlus: "calendar-plus",
  CalendarPlus2: "calendar-plus-2",
  CalendarRange: "calendar-range",
  CalendarSearch: "calendar-search",
  CalendarSync: "calendar-sync",
  CalendarX: "calendar-x",
  CalendarX2: "calendar-x-2",
  Calendars: "calendars",
  Camera: "camera",
  CameraOff: "camera-off",
  Can: "can",
  CanSoda: "can-soda",
  Candy: "candy",
  CandyCane: "candy-cane",
  CandyOff: "candy-off",
  Cannabis: "cannabis",
  CannabisOff: "cannabis-off",
  Captions: "captions",
  CaptionsOff: "captions-off",
  Car: "car",
  CarBattery: "car-battery",
  CarFront: "car-front",
  CarTaxiFront: "car-taxi-front",
  Caravan: "caravan",
  CardSim: "card-sim",
  Carrot: "carrot",
  Carton: "carton",
  CartonOff: "carton-off",
  CaseLower: "case-lower",
  CaseSensitive: "case-sensitive",
  CaseUpper: "case-upper",
  CassetteTape: "cassette-tape",
  Cast: "cast",
  Castle: "castle",
  Cat: "cat",
  Cctv: "cctv",
  CctvOff: "cctv-off",
  ChartArea: "chart-area",
  ChartBar: "chart-bar",
  ChartBarBig: "chart-bar-big",
  ChartBarDecreasing: "chart-bar-decreasing",
  ChartBarIncreasing: "chart-bar-increasing",
  ChartBarStacked: "chart-bar-stacked",
  ChartCandlestick: "chart-candlestick",
  ChartColumn: "chart-column",
  ChartColumnBig: "chart-column-big",
  ChartColumnDecreasing: "chart-column-decreasing",
  ChartColumnIncreasing: "chart-column-increasing",
  ChartColumnStacked: "chart-column-stacked",
  ChartGantt: "chart-gantt",
  ChartLine: "chart-line",
  ChartNetwork: "chart-network",
  ChartNoAxesColumn: "chart-no-axes-column",
  ChartNoAxesColumnDecreasing: "chart-no-axes-column-decreasing",
  ChartNoAxesColumnIncreasing: "chart-no-axes-column-increasing",
  ChartNoAxesCombined: "chart-no-axes-combined",
  ChartNoAxesGantt: "chart-no-axes-gantt",
  ChartPie: "chart-pie",
  ChartScatter: "chart-scatter",
  ChartSpline: "chart-spline",
  Check: "check",
  CheckCheck: "check-check",
  CheckLine: "check-line",
  ChefHat: "chef-hat",
  Cherry: "cherry",
  ChessBishop: "chess-bishop",
  ChessKing: "chess-king",
  ChessKnight: "chess-knight",
  ChessPawn: "chess-pawn",
  ChessQueen: "chess-queen",
  ChessRook: "chess-rook",
  ChevronDown: "chevron-down",
  ChevronFirst: "chevron-first",
  ChevronLast: "chevron-last",
  ChevronLeft: "chevron-left",
  ChevronRight: "chevron-right",
  ChevronUp: "chevron-up",
  ChevronsDown: "chevrons-down",
  ChevronsDownUp: "chevrons-down-up",
  ChevronsLeft: "chevrons-left",
  ChevronsLeftRight: "chevrons-left-right",
  ChevronsLeftRightEllipsis: "chevrons-left-right-ellipsis",
  ChevronsRight: "chevrons-right",
  ChevronsRightLeft: "chevrons-right-left",
  ChevronsUp: "chevrons-up",
  ChevronsUpDown: "chevrons-up-down",
  Church: "church",
  Cigarette: "cigarette",
  CigaretteOff: "cigarette-off",
  Circle: "circle",
  CircleAlert: "circle-alert",
  CircleArrowDown: "circle-arrow-down",
  CircleArrowLeft: "circle-arrow-left",
  CircleArrowOutDownLeft: "circle-arrow-out-down-left",
  CircleArrowOutDownRight: "circle-arrow-out-down-right",
  CircleArrowOutUpLeft: "circle-arrow-out-up-left",
  CircleArrowOutUpRight: "circle-arrow-out-up-right",
  CircleArrowRight: "circle-arrow-right",
  CircleArrowUp: "circle-arrow-up",
  CircleCheck: "circle-check",
  CircleCheckBig: "circle-check-big",
  CircleChevronDown: "circle-chevron-down",
  CircleChevronLeft: "circle-chevron-left",
  CircleChevronRight: "circle-chevron-right",
  CircleChevronUp: "circle-chevron-up",
  CircleDashed: "circle-dashed",
  CircleDashedCheck: "circle-dashed-check",
  CircleDivide: "circle-divide",
  CircleDollarSign: "circle-dollar-sign",
  CircleDot: "circle-dot",
  CircleDotDashed: "circle-dot-dashed",
  CircleEllipsis: "circle-ellipsis",
  CircleEqual: "circle-equal",
  CircleEuro: "circle-euro",
  CircleFadingArrowUp: "circle-fading-arrow-up",
  CircleFadingPlus: "circle-fading-plus",
  CircleGauge: "circle-gauge",
  CircleMinus: "circle-minus",
  CircleOff: "circle-off",
  CircleParking: "circle-parking",
  CircleParkingOff: "circle-parking-off",
  CirclePause: "circle-pause",
  CirclePercent: "circle-percent",
  CirclePile: "circle-pile",
  CirclePlay: "circle-play",
  CirclePlus: "circle-plus",
  CirclePoundSterling: "circle-pound-sterling",
  CirclePower: "circle-power",
  CircleQuestionMark: "circle-question-mark",
  CircleSlash: "circle-slash",
  CircleSlash2: "circle-slash-2",
  CircleSmall: "circle-small",
  CircleStar: "circle-star",
  CircleStop: "circle-stop",
  CircleUser: "circle-user",
  CircleUserRound: "circle-user-round",
  CircleX: "circle-x",
  CircuitBoard: "circuit-board",
  Citrus: "citrus",
  Clapperboard: "clapperboard",
  ClefAlto: "clef-alto",
  ClefBass: "clef-bass",
  ClefTreble: "clef-treble",
  Clipboard: "clipboard",
  ClipboardCheck: "clipboard-check",
  ClipboardClock: "clipboard-clock",
  ClipboardCopy: "clipboard-copy",
  ClipboardList: "clipboard-list",
  ClipboardMinus: "clipboard-minus",
  ClipboardPaste: "clipboard-paste",
  ClipboardPen: "clipboard-pen",
  ClipboardPenLine: "clipboard-pen-line",
  ClipboardPlus: "clipboard-plus",
  ClipboardType: "clipboard-type",
  ClipboardX: "clipboard-x",
  Clock: "clock",
  Clock1: "clock-1",
  Clock10: "clock-10",
  Clock11: "clock-11",
  Clock12: "clock-12",
  Clock2: "clock-2",
  Clock3: "clock-3",
  Clock4: "clock-4",
  Clock5: "clock-5",
  Clock6: "clock-6",
  Clock7: "clock-7",
  Clock8: "clock-8",
  Clock9: "clock-9",
  ClockAlert: "clock-alert",
  ClockArrowDown: "clock-arrow-down",
  ClockArrowLeft: "clock-arrow-left",
  ClockArrowRight: "clock-arrow-right",
  ClockArrowUp: "clock-arrow-up",
  ClockCheck: "clock-check",
  ClockFading: "clock-fading",
  ClockPlus: "clock-plus",
  ClosedCaption: "closed-caption",
  Cloud: "cloud",
  CloudAlert: "cloud-alert",
  CloudBackup: "cloud-backup",
  CloudCheck: "cloud-check",
  CloudCog: "cloud-cog",
  CloudDownload: "cloud-download",
  CloudDrizzle: "cloud-drizzle",
  CloudFog: "cloud-fog",
  CloudHail: "cloud-hail",
  CloudLightning: "cloud-lightning",
  CloudMoon: "cloud-moon",
  CloudMoonRain: "cloud-moon-rain",
  CloudOff: "cloud-off",
  CloudRain: "cloud-rain",
  CloudRainWind: "cloud-rain-wind",
  CloudSnow: "cloud-snow",
  CloudSun: "cloud-sun",
  CloudSunRain: "cloud-sun-rain",
  CloudSync: "cloud-sync",
  CloudUpload: "cloud-upload",
  Cloudy: "cloudy",
  Clover: "clover",
  Club: "club",
  Code: "code",
  CodeXml: "code-xml",
  Coffee: "coffee",
  Cog: "cog",
  Coins: "coins",
  Columns2: "columns-2",
  Columns3: "columns-3",
  Columns3Cog: "columns-3-cog",
  Columns4: "columns-4",
  Combine: "combine",
  Command: "command",
  Compass: "compass",
  Component: "component",
  Computer: "computer",
  ConciergeBell: "concierge-bell",
  Cone: "cone",
  Construction: "construction",
  Contact: "contact",
  ContactRound: "contact-round",
  Container: "container",
  Contrast: "contrast",
  Cookie: "cookie",
  CookingPot: "cooking-pot",
  Copy: "copy",
  CopyCheck: "copy-check",
  CopyMinus: "copy-minus",
  CopyPlus: "copy-plus",
  CopySlash: "copy-slash",
  CopyX: "copy-x",
  Copyleft: "copyleft",
  Copyright: "copyright",
  CornerDownLeft: "corner-down-left",
  CornerDownRight: "corner-down-right",
  CornerLeftDown: "corner-left-down",
  CornerLeftUp: "corner-left-up",
  CornerRightDown: "corner-right-down",
  CornerRightUp: "corner-right-up",
  CornerUpLeft: "corner-up-left",
  CornerUpRight: "corner-up-right",
  Cpu: "cpu",
  CreativeCommons: "creative-commons",
  CreditCard: "credit-card",
  CreditCardCheck: "credit-card-check",
  CreditCardMinus: "credit-card-minus",
  CreditCardPlus: "credit-card-plus",
  CreditCardReader: "credit-card-reader",
  CreditCardX: "credit-card-x",
  Croissant: "croissant",
  Crop: "crop",
  Cross: "cross",
  Crosshair: "crosshair",
  Crown: "crown",
  Cuboid: "cuboid",
  CupSoda: "cup-soda",
  Cupcake: "cupcake",
  Currency: "currency",
  Cylinder: "cylinder",
  Dam: "dam",
  Database: "database",
  DatabaseArrowDown: "database-arrow-down",
  DatabaseArrowUp: "database-arrow-up",
  DatabaseBackup: "database-backup",
  DatabaseCheck: "database-check",
  DatabaseMinus: "database-minus",
  DatabasePlus: "database-plus",
  DatabaseSearch: "database-search",
  DatabaseX: "database-x",
  DatabaseZap: "database-zap",
  DecimalsArrowLeft: "decimals-arrow-left",
  DecimalsArrowRight: "decimals-arrow-right",
  Delete: "delete",
  Dessert: "dessert",
  Diameter: "diameter",
  Diamond: "diamond",
  DiamondMinus: "diamond-minus",
  DiamondPercent: "diamond-percent",
  DiamondPlus: "diamond-plus",
  Dice1: "dice-1",
  Dice2: "dice-2",
  Dice3: "dice-3",
  Dice4: "dice-4",
  Dice5: "dice-5",
  Dice6: "dice-6",
  Dices: "dices",
  Diff: "diff",
  Disc: "disc",
  Disc2: "disc-2",
  Disc3: "disc-3",
  DiscAlbum: "disc-album",
  Divide: "divide",
  Dna: "dna",
  DnaOff: "dna-off",
  Dock: "dock",
  Dog: "dog",
  DollarSign: "dollar-sign",
  Dome: "dome",
  Donut: "donut",
  DoorClosed: "door-closed",
  DoorClosedLocked: "door-closed-locked",
  DoorClosedPackage: "door-closed-package",
  DoorOpen: "door-open",
  DoorStairwell: "door-stairwell",
  Dot: "dot",
  Download: "download",
  DraftingCompass: "drafting-compass",
  Drama: "drama",
  Drill: "drill",
  Drone: "drone",
  Droplet: "droplet",
  DropletOff: "droplet-off",
  Droplets: "droplets",
  Drum: "drum",
  Drumstick: "drumstick",
  Dumbbell: "dumbbell",
  Ear: "ear",
  EarOff: "ear-off",
  Earth: "earth",
  EarthLock: "earth-lock",
  Eclipse: "eclipse",
  Egg: "egg",
  EggFried: "egg-fried",
  EggOff: "egg-off",
  Eject: "eject",
  Ellipse: "ellipse",
  Ellipsis: "ellipsis",
  EllipsisVertical: "ellipsis-vertical",
  Engine: "engine",
  Equal: "equal",
  EqualApproximately: "equal-approximately",
  EqualApproximatelyNot: "equal-approximately-not",
  EqualNot: "equal-not",
  Eraser: "eraser",
  EthernetPort: "ethernet-port",
  Euro: "euro",
  EvCharger: "ev-charger",
  Expand: "expand",
  ExternalLink: "external-link",
  Eye: "eye",
  EyeClosed: "eye-closed",
  EyeDashed: "eye-dashed",
  EyeOff: "eye-off",
  FaceAngry: "face-angry",
  FaceExpressionless: "face-expressionless",
  FaceGrinning: "face-grinning",
  FaceNeutral: "face-neutral",
  FaceSlightlyFrowning: "face-slightly-frowning",
  FaceSlightlySmiling: "face-slightly-smiling",
  FaceSlightlySmilingPlus: "face-slightly-smiling-plus",
  Factory: "factory",
  Fan: "fan",
  FastForward: "fast-forward",
  Faucet: "faucet",
  Feather: "feather",
  Fence: "fence",
  FerrisWheel: "ferris-wheel",
  File: "file",
  FileArchive: "file-archive",
  FileAxis3d: "file-axis-3d",
  FileBadge: "file-badge",
  FileBox: "file-box",
  FileBraces: "file-braces",
  FileBracesCorner: "file-braces-corner",
  FileChartColumn: "file-chart-column",
  FileChartColumnIncreasing: "file-chart-column-increasing",
  FileChartLine: "file-chart-line",
  FileChartPie: "file-chart-pie",
  FileCheck: "file-check",
  FileCheckCorner: "file-check-corner",
  FileClock: "file-clock",
  FileCode: "file-code",
  FileCodeCorner: "file-code-corner",
  FileCog: "file-cog",
  FileDiff: "file-diff",
  FileDigit: "file-digit",
  FileDown: "file-down",
  FileExclamationPoint: "file-exclamation-point",
  FileHeadphone: "file-headphone",
  FileHeart: "file-heart",
  FileImage: "file-image",
  FileInput: "file-input",
  FileKey: "file-key",
  FileLock: "file-lock",
  FileMinus: "file-minus",
  FileMinusCorner: "file-minus-corner",
  FileMusic: "file-music",
  FileOutput: "file-output",
  FilePen: "file-pen",
  FilePenLine: "file-pen-line",
  FilePlay: "file-play",
  FilePlus: "file-plus",
  FilePlusCorner: "file-plus-corner",
  FileQuestionMark: "file-question-mark",
  FileScan: "file-scan",
  FileSearch: "file-search",
  FileSearchCorner: "file-search-corner",
  FileSignal: "file-signal",
  FileSliders: "file-sliders",
  FileSpreadsheet: "file-spreadsheet",
  FileStack: "file-stack",
  FileSymlink: "file-symlink",
  FileTerminal: "file-terminal",
  FileText: "file-text",
  FileType: "file-type",
  FileTypeCorner: "file-type-corner",
  FileUp: "file-up",
  FileUser: "file-user",
  FileVideoCamera: "file-video-camera",
  FileVolume: "file-volume",
  FileX: "file-x",
  FileXCorner: "file-x-corner",
  Files: "files",
  Film: "film",
  FingerprintPattern: "fingerprint-pattern",
  FireExtinguisher: "fire-extinguisher",
  Fish: "fish",
  FishOff: "fish-off",
  FishSymbol: "fish-symbol",
  FishingHook: "fishing-hook",
  FishingRod: "fishing-rod",
  Flag: "flag",
  FlagOff: "flag-off",
  FlagTriangleLeft: "flag-triangle-left",
  FlagTriangleRight: "flag-triangle-right",
  Flame: "flame",
  FlameKindling: "flame-kindling",
  Flashlight: "flashlight",
  FlashlightOff: "flashlight-off",
  FlaskConical: "flask-conical",
  FlaskConicalOff: "flask-conical-off",
  FlaskRound: "flask-round",
  Flower: "flower",
  Flower2: "flower-2",
  Focus: "focus",
  FoldHorizontal: "fold-horizontal",
  FoldVertical: "fold-vertical",
  Folder: "folder",
  FolderArchive: "folder-archive",
  FolderBookmark: "folder-bookmark",
  FolderCheck: "folder-check",
  FolderClock: "folder-clock",
  FolderClosed: "folder-closed",
  FolderCode: "folder-code",
  FolderCog: "folder-cog",
  FolderDot: "folder-dot",
  FolderDown: "folder-down",
  FolderGit: "folder-git",
  FolderGit2: "folder-git-2",
  FolderHeart: "folder-heart",
  FolderInput: "folder-input",
  FolderKanban: "folder-kanban",
  FolderKey: "folder-key",
  FolderLock: "folder-lock",
  FolderMinus: "folder-minus",
  FolderOpen: "folder-open",
  FolderOpenDot: "folder-open-dot",
  FolderOutput: "folder-output",
  FolderPen: "folder-pen",
  FolderPlus: "folder-plus",
  FolderRoot: "folder-root",
  FolderSearch: "folder-search",
  FolderSearch2: "folder-search-2",
  FolderSymlink: "folder-symlink",
  FolderSync: "folder-sync",
  FolderTree: "folder-tree",
  FolderUp: "folder-up",
  FolderX: "folder-x",
  Folders: "folders",
  Footprints: "footprints",
  Forklift: "forklift",
  Form: "form",
  Forward: "forward",
  Frame: "frame",
  Fuel: "fuel",
  Fullscreen: "fullscreen",
  Funnel: "funnel",
  FunnelPlus: "funnel-plus",
  FunnelX: "funnel-x",
  Galaxy: "galaxy",
  GalleryHorizontal: "gallery-horizontal",
  GalleryHorizontalEnd: "gallery-horizontal-end",
  GalleryThumbnails: "gallery-thumbnails",
  GalleryVertical: "gallery-vertical",
  GalleryVerticalEnd: "gallery-vertical-end",
  Gamepad: "gamepad",
  Gamepad2: "gamepad-2",
  GamepadDirectional: "gamepad-directional",
  GapHorizontal: "gap-horizontal",
  GapVertical: "gap-vertical",
  Gauge: "gauge",
  Gavel: "gavel",
  Gem: "gem",
  GeorgianLari: "georgian-lari",
  Germ: "germ",
  GermOff: "germ-off",
  Ghost: "ghost",
  Gift: "gift",
  GitBranch: "git-branch",
  GitBranchMinus: "git-branch-minus",
  GitBranchPlus: "git-branch-plus",
  GitCommitHorizontal: "git-commit-horizontal",
  GitCommitVertical: "git-commit-vertical",
  GitCompare: "git-compare",
  GitCompareArrows: "git-compare-arrows",
  GitFork: "git-fork",
  GitGraph: "git-graph",
  GitMerge: "git-merge",
  GitMergeConflict: "git-merge-conflict",
  GitPullRequest: "git-pull-request",
  GitPullRequestArrow: "git-pull-request-arrow",
  GitPullRequestClosed: "git-pull-request-closed",
  GitPullRequestCreate: "git-pull-request-create",
  GitPullRequestCreateArrow: "git-pull-request-create-arrow",
  GitPullRequestDraft: "git-pull-request-draft",
  GlassWater: "glass-water",
  Glasses: "glasses",
  Globe: "globe",
  GlobeCheck: "globe-check",
  GlobeCode: "globe-code",
  GlobeLock: "globe-lock",
  GlobeOff: "globe-off",
  GlobeX: "globe-x",
  Goal: "goal",
  Gpu: "gpu",
  GraduationCap: "graduation-cap",
  Grape: "grape",
  Grid2x2: "grid-2x2",
  Grid2x2Check: "grid-2x2-check",
  Grid2x2Plus: "grid-2x2-plus",
  Grid2x2X: "grid-2x2-x",
  Grid3x2: "grid-3x2",
  Grid3x3: "grid-3x3",
  Grip: "grip",
  GripHorizontal: "grip-horizontal",
  GripVertical: "grip-vertical",
  Group: "group",
  Guitar: "guitar",
  Ham: "ham",
  Hamburger: "hamburger",
  Hammer: "hammer",
  Hand: "hand",
  HandCoins: "hand-coins",
  HandFist: "hand-fist",
  HandGrab: "hand-grab",
  HandHeart: "hand-heart",
  HandHelping: "hand-helping",
  HandMetal: "hand-metal",
  HandPlatter: "hand-platter",
  Handbag: "handbag",
  Handshake: "handshake",
  HardDrive: "hard-drive",
  HardDriveDownload: "hard-drive-download",
  HardDriveUpload: "hard-drive-upload",
  HardHat: "hard-hat",
  Hash: "hash",
  HatGlasses: "hat-glasses",
  Haze: "haze",
  Hd: "hd",
  HdmiPort: "hdmi-port",
  Heading: "heading",
  Heading1: "heading-1",
  Heading2: "heading-2",
  Heading3: "heading-3",
  Heading4: "heading-4",
  Heading5: "heading-5",
  Heading6: "heading-6",
  HeadphoneOff: "headphone-off",
  Headphones: "headphones",
  Headset: "headset",
  Heart: "heart",
  HeartCrack: "heart-crack",
  HeartHandshake: "heart-handshake",
  HeartMinus: "heart-minus",
  HeartOff: "heart-off",
  HeartPlus: "heart-plus",
  HeartPulse: "heart-pulse",
  HeartX: "heart-x",
  Heater: "heater",
  Helicopter: "helicopter",
  Hexagon: "hexagon",
  Highlighter: "highlighter",
  Hop: "hop",
  HopOff: "hop-off",
  Hospital: "hospital",
  Hotel: "hotel",
  Hourglass: "hourglass",
  HourglassCog: "hourglass-cog",
  House: "house",
  HouseCog: "house-cog",
  HouseHeart: "house-heart",
  HousePlug: "house-plug",
  HousePlus: "house-plus",
  HouseWifi: "house-wifi",
  Houses: "houses",
  IceCreamBowl: "ice-cream-bowl",
  IceCreamCone: "ice-cream-cone",
  IdCard: "id-card",
  IdCardLanyard: "id-card-lanyard",
  Image: "image",
  ImageDown: "image-down",
  ImageMinus: "image-minus",
  ImageOff: "image-off",
  ImagePlay: "image-play",
  ImagePlus: "image-plus",
  ImageUp: "image-up",
  ImageUpscale: "image-upscale",
  Images: "images",
  Import: "import",
  Inbox: "inbox",
  IndianRupee: "indian-rupee",
  Infinity: "infinity",
  Info: "info",
  InspectionPanel: "inspection-panel",
  Italic: "italic",
  IterationCcw: "iteration-ccw",
  IterationCw: "iteration-cw",
  IvBag: "iv-bag",
  JapaneseYen: "japanese-yen",
  Joystick: "joystick",
  Kanban: "kanban",
  Kayak: "kayak",
  Key: "key",
  KeyRound: "key-round",
  KeySquare: "key-square",
  Keyboard: "keyboard",
  KeyboardMusic: "keyboard-music",
  KeyboardOff: "keyboard-off",
  Lambda: "lambda",
  Lamp: "lamp",
  LampCeiling: "lamp-ceiling",
  LampDesk: "lamp-desk",
  LampFloor: "lamp-floor",
  LampWallDown: "lamp-wall-down",
  LampWallUp: "lamp-wall-up",
  LandPlot: "land-plot",
  Landmark: "landmark",
  Languages: "languages",
  Laptop: "laptop",
  LaptopMinimal: "laptop-minimal",
  LaptopMinimalCheck: "laptop-minimal-check",
  Lasso: "lasso",
  LassoSelect: "lasso-select",
  LayerArrowDown: "layer-arrow-down",
  LayerArrowUp: "layer-arrow-up",
  Layers: "layers",
  Layers2: "layers-2",
  LayersArrowDown: "layers-arrow-down",
  LayersArrowUp: "layers-arrow-up",
  LayersMinus: "layers-minus",
  LayersPlus: "layers-plus",
  LayoutArrowDown: "layout-arrow-down",
  LayoutArrowRight: "layout-arrow-right",
  LayoutDashboard: "layout-dashboard",
  LayoutFreeform: "layout-freeform",
  LayoutGrid: "layout-grid",
  LayoutList: "layout-list",
  LayoutPanelLeft: "layout-panel-left",
  LayoutPanelTop: "layout-panel-top",
  LayoutTemplate: "layout-template",
  Leaf: "leaf",
  LeafyGreen: "leafy-green",
  Lectern: "lectern",
  LensConcave: "lens-concave",
  LensConvex: "lens-convex",
  Letters: "letters",
  Library: "library",
  LibraryBig: "library-big",
  LifeBuoy: "life-buoy",
  Ligature: "ligature",
  Lightbulb: "lightbulb",
  LightbulbOff: "lightbulb-off",
  Lighthouse: "lighthouse",
  LineDotBottomVertical: "line-dot-bottom-vertical",
  LineDotLeftHorizontal: "line-dot-left-horizontal",
  LineDotRightHorizontal: "line-dot-right-horizontal",
  LineDotTopVertical: "line-dot-top-vertical",
  LineSquiggle: "line-squiggle",
  LineStyle: "line-style",
  Link: "link",
  Link2: "link-2",
  Link2Off: "link-2-off",
  List: "list",
  ListCheck: "list-check",
  ListChecks: "list-checks",
  ListChevronsDownUp: "list-chevrons-down-up",
  ListChevronsUpDown: "list-chevrons-up-down",
  ListClock: "list-clock",
  ListCollapse: "list-collapse",
  ListEnd: "list-end",
  ListFilter: "list-filter",
  ListFilterPlus: "list-filter-plus",
  ListIndentDecrease: "list-indent-decrease",
  ListIndentIncrease: "list-indent-increase",
  ListMinus: "list-minus",
  ListMusic: "list-music",
  ListOrdered: "list-ordered",
  ListPlus: "list-plus",
  ListRestart: "list-restart",
  ListSortAscending: "list-sort-ascending",
  ListSortDescending: "list-sort-descending",
  ListStart: "list-start",
  ListTodo: "list-todo",
  ListTree: "list-tree",
  ListVideo: "list-video",
  ListX: "list-x",
  Loader: "loader",
  LoaderCircle: "loader-circle",
  LoaderPinwheel: "loader-pinwheel",
  Locate: "locate",
  LocateFixed: "locate-fixed",
  LocateOff: "locate-off",
  Lock: "lock",
  LockKeyhole: "lock-keyhole",
  LockKeyholeOpen: "lock-keyhole-open",
  LockOpen: "lock-open",
  LogIn: "log-in",
  LogOut: "log-out",
  Logs: "logs",
  Lollipop: "lollipop",
  Luggage: "luggage",
  Magnet: "magnet",
  Mail: "mail",
  MailBadge: "mail-badge",
  MailCheck: "mail-check",
  MailClock: "mail-clock",
  MailMinus: "mail-minus",
  MailOpen: "mail-open",
  MailPen: "mail-pen",
  MailPlus: "mail-plus",
  MailQuestionMark: "mail-question-mark",
  MailSearch: "mail-search",
  MailWarning: "mail-warning",
  MailX: "mail-x",
  Mailbox: "mailbox",
  Mails: "mails",
  Map: "map",
  MapMinus: "map-minus",
  MapPin: "map-pin",
  MapPinCheck: "map-pin-check",
  MapPinCheckInside: "map-pin-check-inside",
  MapPinHouse: "map-pin-house",
  MapPinMinus: "map-pin-minus",
  MapPinMinusInside: "map-pin-minus-inside",
  MapPinOff: "map-pin-off",
  MapPinPen: "map-pin-pen",
  MapPinPlus: "map-pin-plus",
  MapPinPlusInside: "map-pin-plus-inside",
  MapPinSearch: "map-pin-search",
  MapPinX: "map-pin-x",
  MapPinXInside: "map-pin-x-inside",
  MapPinned: "map-pinned",
  MapPlus: "map-plus",
  Mars: "mars",
  MarsStroke: "mars-stroke",
  Martini: "martini",
  Maximize: "maximize",
  Maximize2: "maximize-2",
  Medal: "medal",
  Megaphone: "megaphone",
  MegaphoneOff: "megaphone-off",
  MemoryStick: "memory-stick",
  Menu: "menu",
  Merge: "merge",
  MessageCircle: "message-circle",
  MessageCircleCheck: "message-circle-check",
  MessageCircleCode: "message-circle-code",
  MessageCircleDashed: "message-circle-dashed",
  MessageCircleDashedCheck: "message-circle-dashed-check",
  MessageCircleHeart: "message-circle-heart",
  MessageCircleMore: "message-circle-more",
  MessageCircleOff: "message-circle-off",
  MessageCirclePlus: "message-circle-plus",
  MessageCircleQuestionMark: "message-circle-question-mark",
  MessageCircleReply: "message-circle-reply",
  MessageCircleWarning: "message-circle-warning",
  MessageCircleX: "message-circle-x",
  MessageSquare: "message-square",
  MessageSquareCheck: "message-square-check",
  MessageSquareCode: "message-square-code",
  MessageSquareDashed: "message-square-dashed",
  MessageSquareDiff: "message-square-diff",
  MessageSquareDot: "message-square-dot",
  MessageSquareHeart: "message-square-heart",
  MessageSquareLock: "message-square-lock",
  MessageSquareMore: "message-square-more",
  MessageSquareOff: "message-square-off",
  MessageSquarePlus: "message-square-plus",
  MessageSquareQuote: "message-square-quote",
  MessageSquareReply: "message-square-reply",
  MessageSquareShare: "message-square-share",
  MessageSquareText: "message-square-text",
  MessageSquareWarning: "message-square-warning",
  MessageSquareX: "message-square-x",
  MessagesCircle: "messages-circle",
  MessagesSquare: "messages-square",
  Metronome: "metronome",
  Mic: "mic",
  MicAudioLines: "mic-audio-lines",
  MicOff: "mic-off",
  MicSignal: "mic-signal",
  MicVocal: "mic-vocal",
  Microchip: "microchip",
  Microscope: "microscope",
  Microwave: "microwave",
  MidiPort: "midi-port",
  Milestone: "milestone",
  Milk: "milk",
  MilkOff: "milk-off",
  Minimize: "minimize",
  Minimize2: "minimize-2",
  Minus: "minus",
  MirrorRectangular: "mirror-rectangular",
  MirrorRound: "mirror-round",
  Monitor: "monitor",
  MonitorCheck: "monitor-check",
  MonitorCloud: "monitor-cloud",
  MonitorCog: "monitor-cog",
  MonitorDot: "monitor-dot",
  MonitorDown: "monitor-down",
  MonitorOff: "monitor-off",
  MonitorPause: "monitor-pause",
  MonitorPc: "monitor-pc",
  MonitorPlay: "monitor-play",
  MonitorSmartphone: "monitor-smartphone",
  MonitorSpeaker: "monitor-speaker",
  MonitorStop: "monitor-stop",
  MonitorUp: "monitor-up",
  MonitorX: "monitor-x",
  Moon: "moon",
  MoonStar: "moon-star",
  Mop: "mop",
  MopSparkles: "mop-sparkles",
  Mosque: "mosque",
  Motorbike: "motorbike",
  Mountain: "mountain",
  MountainSnow: "mountain-snow",
  Mouse: "mouse",
  MouseLeft: "mouse-left",
  MouseOff: "mouse-off",
  MousePointer: "mouse-pointer",
  MousePointer2: "mouse-pointer-2",
  MousePointer2Off: "mouse-pointer-2-off",
  MousePointerBan: "mouse-pointer-ban",
  MousePointerClick: "mouse-pointer-click",
  MouseRight: "mouse-right",
  Mouth: "mouth",
  MouthOff: "mouth-off",
  Move: "move",
  Move3d: "move-3d",
  MoveDiagonal: "move-diagonal",
  MoveDiagonal2: "move-diagonal-2",
  MoveDown: "move-down",
  MoveDownLeft: "move-down-left",
  MoveDownRight: "move-down-right",
  MoveHorizontal: "move-horizontal",
  MoveLeft: "move-left",
  MoveRight: "move-right",
  MoveUp: "move-up",
  MoveUpLeft: "move-up-left",
  MoveUpRight: "move-up-right",
  MoveVertical: "move-vertical",
  Music: "music",
  Music2: "music-2",
  Music3: "music-3",
  Music4: "music-4",
  Navigation: "navigation",
  Navigation2: "navigation-2",
  Navigation2Off: "navigation-2-off",
  NavigationOff: "navigation-off",
  NepaliRupee: "nepali-rupee",
  Network: "network",
  Newspaper: "newspaper",
  Nfc: "nfc",
  NonBinary: "non-binary",
  Notebook: "notebook",
  NotebookDot: "notebook-dot",
  NotebookPen: "notebook-pen",
  NotebookTabs: "notebook-tabs",
  NotebookText: "notebook-text",
  NotepadText: "notepad-text",
  NotepadTextDashed: "notepad-text-dashed",
  Nut: "nut",
  NutOff: "nut-off",
  Octagon: "octagon",
  OctagonAlert: "octagon-alert",
  OctagonMinus: "octagon-minus",
  OctagonPause: "octagon-pause",
  OctagonX: "octagon-x",
  Omega: "omega",
  Option: "option",
  Orbit: "orbit",
  Origami: "origami",
  Package: "package",
  Package2: "package-2",
  PackageCheck: "package-check",
  PackageMinus: "package-minus",
  PackageOpen: "package-open",
  PackagePlus: "package-plus",
  PackageSearch: "package-search",
  PackageX: "package-x",
  PaintBucket: "paint-bucket",
  PaintRoller: "paint-roller",
  Paintbrush: "paintbrush",
  PaintbrushVertical: "paintbrush-vertical",
  Palette: "palette",
  Panda: "panda",
  PanelBottom: "panel-bottom",
  PanelBottomClose: "panel-bottom-close",
  PanelBottomDashed: "panel-bottom-dashed",
  PanelBottomOpen: "panel-bottom-open",
  PanelLeft: "panel-left",
  PanelLeftClose: "panel-left-close",
  PanelLeftDashed: "panel-left-dashed",
  PanelLeftOpen: "panel-left-open",
  PanelLeftRightDashed: "panel-left-right-dashed",
  PanelRight: "panel-right",
  PanelRightClose: "panel-right-close",
  PanelRightDashed: "panel-right-dashed",
  PanelRightOpen: "panel-right-open",
  PanelTop: "panel-top",
  PanelTopBottomDashed: "panel-top-bottom-dashed",
  PanelTopClose: "panel-top-close",
  PanelTopDashed: "panel-top-dashed",
  PanelTopOpen: "panel-top-open",
  PanelsLeftBottom: "panels-left-bottom",
  PanelsRightBottom: "panels-right-bottom",
  PanelsTopLeft: "panels-top-left",
  PaperBag: "paper-bag",
  Paperclip: "paperclip",
  Parasol: "parasol",
  Parentheses: "parentheses",
  Park: "park",
  ParkingMeter: "parking-meter",
  PartyPopper: "party-popper",
  Pause: "pause",
  PawPrint: "paw-print",
  PcCase: "pc-case",
  Pen: "pen",
  PenLine: "pen-line",
  PenOff: "pen-off",
  PenTool: "pen-tool",
  Pencil: "pencil",
  PencilLine: "pencil-line",
  PencilOff: "pencil-off",
  PencilRuler: "pencil-ruler",
  PencilSparkles: "pencil-sparkles",
  Pentagon: "pentagon",
  Percent: "percent",
  PersonStanding: "person-standing",
  Phi: "phi",
  PhilippinePeso: "philippine-peso",
  Phone: "phone",
  PhoneCall: "phone-call",
  PhoneForwarded: "phone-forwarded",
  PhoneIncoming: "phone-incoming",
  PhoneMissed: "phone-missed",
  PhoneOff: "phone-off",
  PhoneOutgoing: "phone-outgoing",
  Pi: "pi",
  Piano: "piano",
  Pickaxe: "pickaxe",
  PictureInPicture: "picture-in-picture",
  PictureInPicture2: "picture-in-picture-2",
  PiggyBank: "piggy-bank",
  Pilcrow: "pilcrow",
  PilcrowLeft: "pilcrow-left",
  PilcrowRight: "pilcrow-right",
  Pill: "pill",
  PillBottle: "pill-bottle",
  Pin: "pin",
  PinOff: "pin-off",
  Pipette: "pipette",
  Pizza: "pizza",
  Plane: "plane",
  PlaneLanding: "plane-landing",
  PlaneTakeoff: "plane-takeoff",
  PlantPot: "plant-pot",
  Play: "play",
  PlayOff: "play-off",
  PlayingCard: "playing-card",
  PlayingCards: "playing-cards",
  PlayingCardsFan: "playing-cards-fan",
  Plug: "plug",
  Plug2: "plug-2",
  PlugZap: "plug-zap",
  Plus: "plus",
  PocketKnife: "pocket-knife",
  Podium: "podium",
  Pointer: "pointer",
  PointerOff: "pointer-off",
  Popcorn: "popcorn",
  Popsicle: "popsicle",
  PoundSterling: "pound-sterling",
  Power: "power",
  PowerOff: "power-off",
  Presentation: "presentation",
  Printer: "printer",
  Printer3d: "printer-3d",
  PrinterCheck: "printer-check",
  PrinterX: "printer-x",
  Projector: "projector",
  Proportions: "proportions",
  Puzzle: "puzzle",
  Pyramid: "pyramid",
  QrCode: "qr-code",
  Quote: "quote",
  Rabbit: "rabbit",
  Radar: "radar",
  Radiation: "radiation",
  Radical: "radical",
  Radio: "radio",
  RadioOff: "radio-off",
  RadioReceiver: "radio-receiver",
  RadioTower: "radio-tower",
  Radius: "radius",
  Rainbow: "rainbow",
  Rat: "rat",
  Ratio: "ratio",
  Receipt: "receipt",
  ReceiptCent: "receipt-cent",
  ReceiptEuro: "receipt-euro",
  ReceiptIndianRupee: "receipt-indian-rupee",
  ReceiptJapaneseYen: "receipt-japanese-yen",
  ReceiptPoundSterling: "receipt-pound-sterling",
  ReceiptRussianRuble: "receipt-russian-ruble",
  ReceiptSwissFranc: "receipt-swiss-franc",
  ReceiptText: "receipt-text",
  ReceiptTurkishLira: "receipt-turkish-lira",
  RectangleCircle: "rectangle-circle",
  RectangleEllipsis: "rectangle-ellipsis",
  RectangleGoggles: "rectangle-goggles",
  RectangleHorizontal: "rectangle-horizontal",
  RectangleVertical: "rectangle-vertical",
  Recycle: "recycle",
  Redo: "redo",
  Redo2: "redo-2",
  RedoDot: "redo-dot",
  RefreshCcw: "refresh-ccw",
  RefreshCcwDot: "refresh-ccw-dot",
  RefreshCw: "refresh-cw",
  RefreshCwOff: "refresh-cw-off",
  Refrigerator: "refrigerator",
  Regex: "regex",
  RemoveFormatting: "remove-formatting",
  Repeat: "repeat",
  Repeat1: "repeat-1",
  Repeat2: "repeat-2",
  RepeatOff: "repeat-off",
  Replace: "replace",
  ReplaceAll: "replace-all",
  Reply: "reply",
  ReplyAll: "reply-all",
  Rewind: "rewind",
  Ribbon: "ribbon",
  Road: "road",
  RobotArm: "robot-arm",
  RobotVacuum: "robot-vacuum",
  Rocket: "rocket",
  RockingChair: "rocking-chair",
  RollerCoaster: "roller-coaster",
  Rose: "rose",
  Rotate3d: "rotate-3d",
  RotateCcw: "rotate-ccw",
  RotateCcwClock: "rotate-ccw-clock",
  RotateCcwKey: "rotate-ccw-key",
  RotateCcwSquare: "rotate-ccw-square",
  RotateCw: "rotate-cw",
  RotateCwClock: "rotate-cw-clock",
  RotateCwFadingClock: "rotate-cw-fading-clock",
  RotateCwSquare: "rotate-cw-square",
  Route: "route",
  RouteOff: "route-off",
  Router: "router",
  Rows2: "rows-2",
  Rows3: "rows-3",
  Rows4: "rows-4",
  Rss: "rss",
  Ruler: "ruler",
  RulerDimensionLine: "ruler-dimension-line",
  RussianRuble: "russian-ruble",
  Sailboat: "sailboat",
  Salad: "salad",
  Sandwich: "sandwich",
  Satellite: "satellite",
  SatelliteDish: "satellite-dish",
  SaudiRiyal: "saudi-riyal",
  Save: "save",
  SaveAll: "save-all",
  SaveCheck: "save-check",
  SaveOff: "save-off",
  SavePen: "save-pen",
  SavePlus: "save-plus",
  Scale: "scale",
  Scale3d: "scale-3d",
  Scaling: "scaling",
  Scan: "scan",
  ScanBarcode: "scan-barcode",
  ScanBox: "scan-box",
  ScanEye: "scan-eye",
  ScanFace: "scan-face",
  ScanHeart: "scan-heart",
  ScanLine: "scan-line",
  ScanQrCode: "scan-qr-code",
  ScanSearch: "scan-search",
  ScanSquare: "scan-square",
  ScanText: "scan-text",
  School: "school",
  Scissors: "scissors",
  ScissorsLineDashed: "scissors-line-dashed",
  Scooter: "scooter",
  ScreenShare: "screen-share",
  ScreenShareOff: "screen-share-off",
  Scroll: "scroll",
  ScrollText: "scroll-text",
  Search: "search",
  SearchAlert: "search-alert",
  SearchCheck: "search-check",
  SearchCode: "search-code",
  SearchSlash: "search-slash",
  SearchX: "search-x",
  Section: "section",
  Send: "send",
  SendHorizontal: "send-horizontal",
  SendToBack: "send-to-back",
  SeparatorHorizontal: "separator-horizontal",
  SeparatorVertical: "separator-vertical",
  Server: "server",
  ServerCog: "server-cog",
  ServerCrash: "server-crash",
  ServerOff: "server-off",
  ServerPlus: "server-plus",
  Settings: "settings",
  Settings2: "settings-2",
  Shapes: "shapes",
  Share: "share",
  Share2: "share-2",
  Sheet: "sheet",
  Shell: "shell",
  ShelvingUnit: "shelving-unit",
  Shield: "shield",
  ShieldAlert: "shield-alert",
  ShieldBan: "shield-ban",
  ShieldCheck: "shield-check",
  ShieldCog: "shield-cog",
  ShieldCogCorner: "shield-cog-corner",
  ShieldEllipsis: "shield-ellipsis",
  ShieldHalf: "shield-half",
  ShieldKeyhole: "shield-keyhole",
  ShieldLock: "shield-lock",
  ShieldMinus: "shield-minus",
  ShieldOff: "shield-off",
  ShieldPlus: "shield-plus",
  ShieldQuestionMark: "shield-question-mark",
  ShieldUser: "shield-user",
  ShieldX: "shield-x",
  Ship: "ship",
  ShipCargo: "ship-cargo",
  ShipWheel: "ship-wheel",
  Shirt: "shirt",
  ShoppingBag: "shopping-bag",
  ShoppingBasket: "shopping-basket",
  ShoppingCart: "shopping-cart",
  ShoppingCartMinus: "shopping-cart-minus",
  ShoppingCartPlus: "shopping-cart-plus",
  Shovel: "shovel",
  ShowerHead: "shower-head",
  Shredder: "shredder",
  Shrimp: "shrimp",
  ShrimpOff: "shrimp-off",
  Shrink: "shrink",
  Shrub: "shrub",
  Shuffle: "shuffle",
  Sigma: "sigma",
  Signal: "signal",
  SignalHigh: "signal-high",
  SignalLow: "signal-low",
  SignalMedium: "signal-medium",
  SignalZero: "signal-zero",
  Signature: "signature",
  Signpost: "signpost",
  SignpostBig: "signpost-big",
  Siren: "siren",
  SkipBack: "skip-back",
  SkipForward: "skip-forward",
  Skull: "skull",
  Slash: "slash",
  Slice: "slice",
  SlidersHorizontal: "sliders-horizontal",
  SlidersVertical: "sliders-vertical",
  Smartphone: "smartphone",
  SmartphoneCharging: "smartphone-charging",
  SmartphoneNfc: "smartphone-nfc",
  Snail: "snail",
  Snowflake: "snowflake",
  SoapDispenserDroplet: "soap-dispenser-droplet",
  Sofa: "sofa",
  SolarPanel: "solar-panel",
  Soup: "soup",
  Space: "space",
  Spade: "spade",
  Sparkle: "sparkle",
  Sparkles: "sparkles",
  Speaker: "speaker",
  Speech: "speech",
  SpellCheck: "spell-check",
  SpellCheck2: "spell-check-2",
  Spline: "spline",
  SplinePointer: "spline-pointer",
  Split: "split",
  Spool: "spool",
  SportShoe: "sport-shoe",
  Spotlight: "spotlight",
  SprayCan: "spray-can",
  Sprout: "sprout",
  Square: "square",
  SquareActivity: "square-activity",
  SquareArrowDown: "square-arrow-down",
  SquareArrowDownLeft: "square-arrow-down-left",
  SquareArrowDownRight: "square-arrow-down-right",
  SquareArrowLeft: "square-arrow-left",
  SquareArrowOutDownLeft: "square-arrow-out-down-left",
  SquareArrowOutDownRight: "square-arrow-out-down-right",
  SquareArrowOutUpLeft: "square-arrow-out-up-left",
  SquareArrowOutUpRight: "square-arrow-out-up-right",
  SquareArrowRight: "square-arrow-right",
  SquareArrowRightEnter: "square-arrow-right-enter",
  SquareArrowRightExit: "square-arrow-right-exit",
  SquareArrowUp: "square-arrow-up",
  SquareArrowUpLeft: "square-arrow-up-left",
  SquareArrowUpRight: "square-arrow-up-right",
  SquareAsterisk: "square-asterisk",
  SquareBookmark: "square-bookmark",
  SquareBottomDashedScissors: "square-bottom-dashed-scissors",
  SquareCenterlineDashedHorizontal: "square-centerline-dashed-horizontal",
  SquareCenterlineDashedVertical: "square-centerline-dashed-vertical",
  SquareChartGantt: "square-chart-gantt",
  SquareCheck: "square-check",
  SquareCheckBig: "square-check-big",
  SquareChevronDown: "square-chevron-down",
  SquareChevronLeft: "square-chevron-left",
  SquareChevronRight: "square-chevron-right",
  SquareChevronUp: "square-chevron-up",
  SquareCode: "square-code",
  SquareDashed: "square-dashed",
  SquareDashedBottom: "square-dashed-bottom",
  SquareDashedBottomCode: "square-dashed-bottom-code",
  SquareDashedKanban: "square-dashed-kanban",
  SquareDashedMousePointer: "square-dashed-mouse-pointer",
  SquareDashedPlus: "square-dashed-plus",
  SquareDashedText: "square-dashed-text",
  SquareDashedTopSolid: "square-dashed-top-solid",
  SquareDashedX: "square-dashed-x",
  SquareDashedXCorner: "square-dashed-x-corner",
  SquareDimensions: "square-dimensions",
  SquareDivide: "square-divide",
  SquareDot: "square-dot",
  SquareEqual: "square-equal",
  SquareExclamationPoint: "square-exclamation-point",
  SquareFunction: "square-function",
  SquareKanban: "square-kanban",
  SquareLibrary: "square-library",
  SquareM: "square-m",
  SquareMenu: "square-menu",
  SquareMinus: "square-minus",
  SquareMousePointer: "square-mouse-pointer",
  SquareOff: "square-off",
  SquareParking: "square-parking",
  SquareParkingOff: "square-parking-off",
  SquarePause: "square-pause",
  SquarePen: "square-pen",
  SquarePercent: "square-percent",
  SquarePi: "square-pi",
  SquarePilcrow: "square-pilcrow",
  SquarePlay: "square-play",
  SquarePlus: "square-plus",
  SquarePower: "square-power",
  SquareRadical: "square-radical",
  SquareRoundCorner: "square-round-corner",
  SquareScissors: "square-scissors",
  SquareSigma: "square-sigma",
  SquareSlash: "square-slash",
  SquareSparkles: "square-sparkles",
  SquareSplitHorizontal: "square-split-horizontal",
  SquareSplitVertical: "square-split-vertical",
  SquareSquare: "square-square",
  SquareStack: "square-stack",
  SquareStar: "square-star",
  SquareStop: "square-stop",
  SquareTerminal: "square-terminal",
  SquareText: "square-text",
  SquareUser: "square-user",
  SquareUserRound: "square-user-round",
  SquareX: "square-x",
  SquaresExclude: "squares-exclude",
  SquaresIntersect: "squares-intersect",
  SquaresSubtract: "squares-subtract",
  SquaresUnite: "squares-unite",
  Squircle: "squircle",
  SquircleDashed: "squircle-dashed",
  Squirrel: "squirrel",
  Stamp: "stamp",
  Star: "star",
  StarCheck: "star-check",
  StarHalf: "star-half",
  StarMinus: "star-minus",
  StarOff: "star-off",
  StarPlus: "star-plus",
  StarX: "star-x",
  StepBack: "step-back",
  StepForward: "step-forward",
  Stethoscope: "stethoscope",
  Sticker: "sticker",
  StickyNote: "sticky-note",
  StickyNoteCheck: "sticky-note-check",
  StickyNoteMinus: "sticky-note-minus",
  StickyNoteOff: "sticky-note-off",
  StickyNotePlus: "sticky-note-plus",
  StickyNoteX: "sticky-note-x",
  StickyNotes: "sticky-notes",
  Stone: "stone",
  Store: "store",
  StretchHorizontal: "stretch-horizontal",
  StretchVertical: "stretch-vertical",
  Strikethrough: "strikethrough",
  Subscript: "subscript",
  Summary: "summary",
  Sun: "sun",
  SunDim: "sun-dim",
  SunMedium: "sun-medium",
  SunMoon: "sun-moon",
  SunSnow: "sun-snow",
  Sunrise: "sunrise",
  Sunset: "sunset",
  Superscript: "superscript",
  SwatchBook: "swatch-book",
  SwissFranc: "swiss-franc",
  SwitchCamera: "switch-camera",
  Sword: "sword",
  Swords: "swords",
  Syringe: "syringe",
  Table: "table",
  Table2: "table-2",
  TableCellsMerge: "table-cells-merge",
  TableCellsSplit: "table-cells-split",
  TableColumnsSplit: "table-columns-split",
  TableOfContents: "table-of-contents",
  TableProperties: "table-properties",
  TableRowsSplit: "table-rows-split",
  Tablet: "tablet",
  TabletSmartphone: "tablet-smartphone",
  Tablets: "tablets",
  Tag: "tag",
  TagPlus: "tag-plus",
  TagX: "tag-x",
  Tags: "tags",
  Tally1: "tally-1",
  Tally2: "tally-2",
  Tally3: "tally-3",
  Tally4: "tally-4",
  Tally5: "tally-5",
  Tangent: "tangent",
  Target: "target",
  Telescope: "telescope",
  Tent: "tent",
  TentTree: "tent-tree",
  Terminal: "terminal",
  TestTube: "test-tube",
  TestTubeDiagonal: "test-tube-diagonal",
  TestTubes: "test-tubes",
  TextAlignCenter: "text-align-center",
  TextAlignEnd: "text-align-end",
  TextAlignJustify: "text-align-justify",
  TextAlignStart: "text-align-start",
  TextCursor: "text-cursor",
  TextCursorInput: "text-cursor-input",
  TextInitial: "text-initial",
  TextQuote: "text-quote",
  TextSearch: "text-search",
  TextWrap: "text-wrap",
  Theater: "theater",
  Thermometer: "thermometer",
  ThermometerSnowflake: "thermometer-snowflake",
  ThermometerSun: "thermometer-sun",
  ThumbsDown: "thumbs-down",
  ThumbsUp: "thumbs-up",
  TicTacToe: "tic-tac-toe",
  Ticket: "ticket",
  TicketCheck: "ticket-check",
  TicketMinus: "ticket-minus",
  TicketPercent: "ticket-percent",
  TicketPlus: "ticket-plus",
  TicketSlash: "ticket-slash",
  TicketX: "ticket-x",
  Tickets: "tickets",
  TicketsPlane: "tickets-plane",
  Timeline: "timeline",
  Timer: "timer",
  TimerOff: "timer-off",
  TimerReset: "timer-reset",
  ToggleLeft: "toggle-left",
  ToggleRight: "toggle-right",
  Toilet: "toilet",
  ToolCase: "tool-case",
  Toolbox: "toolbox",
  Toothbrush: "toothbrush",
  ToothbrushSparkles: "toothbrush-sparkles",
  Tornado: "tornado",
  Torus: "torus",
  Touchpad: "touchpad",
  TouchpadOff: "touchpad-off",
  TowelRack: "towel-rack",
  TowerControl: "tower-control",
  ToyBrick: "toy-brick",
  Tractor: "tractor",
  TrafficCone: "traffic-cone",
  Trailer: "trailer",
  TrainFront: "train-front",
  TrainFrontTunnel: "train-front-tunnel",
  TrainTrack: "train-track",
  TramFront: "tram-front",
  Transgender: "transgender",
  Trash: "trash",
  TrashOff: "trash-off",
  TreeDeciduous: "tree-deciduous",
  TreePalm: "tree-palm",
  TreePine: "tree-pine",
  Trees: "trees",
  TrendingDown: "trending-down",
  TrendingUp: "trending-up",
  TrendingUpDown: "trending-up-down",
  Triangle: "triangle",
  TriangleAlert: "triangle-alert",
  TriangleDashed: "triangle-dashed",
  TriangleRight: "triangle-right",
  TrianglesCenterlineDashedHorizontal: "triangles-centerline-dashed-horizontal",
  TrianglesCenterlineDashedVertical: "triangles-centerline-dashed-vertical",
  Trophy: "trophy",
  Truck: "truck",
  TruckElectric: "truck-electric",
  TubeLotion: "tube-lotion",
  TurkishLira: "turkish-lira",
  Turntable: "turntable",
  Turtle: "turtle",
  Tv: "tv",
  TvMinimal: "tv-minimal",
  TvMinimalPlay: "tv-minimal-play",
  Type: "type",
  TypeOutline: "type-outline",
  Umbrella: "umbrella",
  UmbrellaOff: "umbrella-off",
  Underline: "underline",
  Undo: "undo",
  Undo2: "undo-2",
  UndoDot: "undo-dot",
  UnfoldHorizontal: "unfold-horizontal",
  UnfoldVertical: "unfold-vertical",
  Ungroup: "ungroup",
  University: "university",
  Unlink: "unlink",
  Unlink2: "unlink-2",
  Unplug: "unplug",
  Upload: "upload",
  Usb: "usb",
  UsbCPort: "usb-c-port",
  User: "user",
  UserCheck: "user-check",
  UserCog: "user-cog",
  UserGroup: "user-group",
  UserKey: "user-key",
  UserLock: "user-lock",
  UserMinus: "user-minus",
  UserPen: "user-pen",
  UserPlus: "user-plus",
  UserRound: "user-round",
  UserRoundArrowLeft: "user-round-arrow-left",
  UserRoundCheck: "user-round-check",
  UserRoundCog: "user-round-cog",
  UserRoundGroup: "user-round-group",
  UserRoundKey: "user-round-key",
  UserRoundMinus: "user-round-minus",
  UserRoundPen: "user-round-pen",
  UserRoundPlus: "user-round-plus",
  UserRoundSearch: "user-round-search",
  UserRoundX: "user-round-x",
  UserSearch: "user-search",
  UserShield: "user-shield",
  UserStar: "user-star",
  UserX: "user-x",
  Users: "users",
  UsersRound: "users-round",
  Utensils: "utensils",
  UtensilsCrossed: "utensils-crossed",
  UtilityPole: "utility-pole",
  Van: "van",
  Variable: "variable",
  Vault: "vault",
  VectorPolygon: "vector-polygon",
  VectorSquare: "vector-square",
  Vegan: "vegan",
  VenetianMask: "venetian-mask",
  Venus: "venus",
  VenusAndMars: "venus-and-mars",
  Vibrate: "vibrate",
  VibrateOff: "vibrate-off",
  Video: "video",
  VideoOff: "video-off",
  Videotape: "videotape",
  View: "view",
  Virus: "virus",
  VirusOff: "virus-off",
  Voicemail: "voicemail",
  Volleyball: "volleyball",
  Volume: "volume",
  Volume1: "volume-1",
  Volume2: "volume-2",
  VolumeOff: "volume-off",
  VolumeX: "volume-x",
  Vote: "vote",
  Wallet: "wallet",
  WalletCards: "wallet-cards",
  WalletMinimal: "wallet-minimal",
  Wallpaper: "wallpaper",
  Wand: "wand",
  WandSparkles: "wand-sparkles",
  Warehouse: "warehouse",
  WashingMachine: "washing-machine",
  Watch: "watch",
  WavesArrowDown: "waves-arrow-down",
  WavesArrowUp: "waves-arrow-up",
  WavesHorizontal: "waves-horizontal",
  WavesLadder: "waves-ladder",
  WavesVertical: "waves-vertical",
  Waypoints: "waypoints",
  Webcam: "webcam",
  WebcamOff: "webcam-off",
  Webhook: "webhook",
  WebhookOff: "webhook-off",
  Weight: "weight",
  WeightTilde: "weight-tilde",
  Wheat: "wheat",
  WheatOff: "wheat-off",
  Whistle: "whistle",
  WholeWord: "whole-word",
  Wifi: "wifi",
  WifiCog: "wifi-cog",
  WifiHigh: "wifi-high",
  WifiLow: "wifi-low",
  WifiOff: "wifi-off",
  WifiPen: "wifi-pen",
  WifiSync: "wifi-sync",
  WifiZero: "wifi-zero",
  Wind: "wind",
  WindArrowDown: "wind-arrow-down",
  Wine: "wine",
  WineOff: "wine-off",
  Workflow: "workflow",
  Worm: "worm",
  Wrench: "wrench",
  WrenchOff: "wrench-off",
  X: "x",
  XLineTop: "x-line-top",
  Zap: "zap",
  ZapOff: "zap-off",
  ZodiacAquarius: "zodiac-aquarius",
  ZodiacAries: "zodiac-aries",
  ZodiacCancer: "zodiac-cancer",
  ZodiacCapricorn: "zodiac-capricorn",
  ZodiacGemini: "zodiac-gemini",
  ZodiacLeo: "zodiac-leo",
  ZodiacLibra: "zodiac-libra",
  ZodiacOphiuchus: "zodiac-ophiuchus",
  ZodiacPisces: "zodiac-pisces",
  ZodiacSagittarius: "zodiac-sagittarius",
  ZodiacScorpio: "zodiac-scorpio",
  ZodiacTaurus: "zodiac-taurus",
  ZodiacVirgo: "zodiac-virgo",
  ZoomIn: "zoom-in",
  ZoomOut: "zoom-out",
} as const;

export type IconName = keyof typeof ICON_NAME_TO_KEBAB;
